module.exports = __webpack_public_path__ + "media/src/components/shared/general/img/hhPremiumLogo-9884919c3793b3fc63d0901cad3a7272.png";